'use strict';

const frontEndRootUrl =
  location.protocol + '//api-' + location.host.replace('www.', '') + '/tcmanagementtoolfs/rest/v1';
const config = {
  SSOLogoutUrl: 'https://sso-replica.crfbox.fi/idp/startSLO.ping',
  defaultFetchTimeout: 5000,
  tokenRefreshTimeout: 60 * 60 * 10 ** 3, //  1h
  oktaStorageId: 'econsent-web',
  oktaClientIdDEV: '0oa91qfky2VpIE1Hr0x7',
  oktaIssuerDEV: 'https://fd.idp-dev.signanthealth.dev/oauth2/default',
  oktaClientIdQA: '0oa98tkhl9L3fLz000x7',
  oktaIssuerQA: 'https://fd.idp-qa.signanthealth.dev/oauth2/default',
  oktaClientId: '0oaja33iepD6nROOJ417',
  oktaIssuer: 'https://auth.idportal.signanthealth.com/oauth2/default',
  oktaRedirectPath: frontEndRootUrl + '/sso?Referer=' + location.origin + '/manager',
  oktaPostLogoutUrl: location.origin + '/manager/',
  clientConfigurationUrl: '/ClientConfiguration',
  acsEligibility: 'acs/eligibility',
  acsMigrate: 'acs/migrate',
  domain: location.protocol + '//api-' + location.host.replace('www.', ''),
  apiversion: '/rest/v1',
  mtfs: {
    root: '/tcmanagementtoolfs',
    path: {
      auth: '/users/authenticate',
      clientConfig: '/ClientConfiguration',
      deleteTokens: '/sso/reset',
      refreshTokens: '/sso/refreshTokens',
      deleteQlik: '/sso/invalidateQlik',
      people: '/users/sponsors/:sponsor',
      getUser: '/users/:userId',
      studies: '/studies',
      participants: '/study/:studyGid/participant',
      notes: '/note/study/:studyGid/participant/:participantId',
      notesPDF: '/note/study/:studyGid/participant/:participantId/pdf',
      documents: '/study/:studyGid/participant/:participantId/documents',
      subjectPhi: '/study/:studyGid/participant/:participantId',
      study: '/studies/:studyGid',
      sites: '/study/:studyGid/participant/:participantId/sites',
      consentDocument: '/consent/:consentGid',
      addNote: '/note/:consentingGid',
      documentPendingPdf: '/consent/:consentId/consenting/:consentingId/pdfs',
      documentSignedPdf: '/consenting/:consentingId/pdfs',
      documentUnassignedPdf: '/consent/:consentGid/pdf',
      roles: '/roles',
      userAssignments: '/assignments/:userId',
      assignments: '/assignments/:assignmentId',
      documentStatuses: '/consenting/statuses/:consentingGid',
      saveDocumentStatus: '/consenting/:consentingGid/status/:status',
      userRolesForSponsor: '/users/:userId/sponsors/:sponsor/roles',
      consentingJournal: '/consenting/:consentingGid/journal',
      consentingJournalPDF: '/consenting/:consentingGid/journal/pdf',
      getMonitors: '/users/sponsors/:sponsor/connected',
      consenting: '/document/data/:consentingGid',
      saveParticipantStatus: '/participantjourney/status',
      getFinalParticipantStatuses: '/participantjourney/status/final',
      resetParticipantStatus: '/participantjourney/:participantJourneyGid/status/reset',
      getParticipantStatuses: '/participantjourney/status/all',
      participantJourney: '/participantjourney/:participantJourneyGid',
      participantJournal: '/participantjourney/:participantJourneyGid/journal',
      getOverallParticipantStatus: '/study/:studyGid/participant/overallstatus',
      organizationsByStudy: '/organizations/study/:studyGid',
      organizationsBySponsor: '/organizations/sponsors/:sponsor',
      participantJournalPDF: '/participantjourney/:participantJourneyGid/journal/pdf',
      optInQuestionsReport: 'choiceanswers/report',
      optInQuestionsReportAll: 'choiceanswers/report/all',
      uploadSignedPdf: '/consenting/:consentingGid/signed',
      deleteSignedPdf: '/consenting/signed/:consentingGid',
      delegationLog: '/users/studyPersonnel',
      delegationLogExport: '/users/export/studyPersonnel',
      fetchAvailableDocuments: '/consent/participant/:participantJourneyGid/latest',
      assignParticipantDocument: '/participantdocument/:participantJourneyGid/consent/:consentId/:operation',
      accessRightsChangesReport: '/studies/:studyGid/reports/memberslog',
      startSLO: '/sso/startSLO',
      checkParticipantHasNewVersions: '/participantjourney/:participantJourneyGid/checknewconsents',
      tenantCookie: '/tenant/:tenantId/cookie',
      participantEmail: '/participantjourney/:participantJourneyGid/email',
      qamanagementData: '/choiceanswers/details/:participantId',
      qamanagementUpdateItemIdUrl: '/choiceanswers/:documentGid/:documentVersion/:questionId/biosample',
      qamanagementDataDocumentVersion: '/choiceanswers/details/:participantId/:documentGid/:documentVersion',
      optInOptOutConsentingState: '/choiceanswers/document/:consentingGid',
      addendumPdf: '/addendum/:addendumId/pdf',
      changeAnswers: '/addendum/changeanswers/:consentingGid',
      deleteSignedOnPaperAddendumPdf: '/addendum/signed-on-paper/:addendumId',
      participantGender: '/subjects/:participantId/gender',
      participantBirthdate: '/subjects/:participantId/birthdate',
      participantAddress: '/subjects/:participantId/address',

      // todo: refactor this code - there is duplication in all these files as new endpoint must be added in all
      reports: '/reports/:sponsorGid/:userId',
      qlikSession: '/reports/session/:sponsorGid/:userId',
      reportsStatus: '/reports/status/:sponsorGid',
      countSignedConsentings: '/consenting/signed/count',
      exportArchive: '/batch/archive',
      batchDownload: '/batch/download',
      batchDownloadCancel: '/batch/download/cancel',
      batchProgress: '/batch/progress',
      batchCancelExport: '/batch/cancel',
      batchArchivingStatus: '/batch/archiving/status',
      consentingMetadata: '/document/data/:consentingGid',
      signedPdf: 'consenting/store/pdf/:consentingGid'
    }
  }
};

module.exports = Object.freeze(config);
